
export const goToCreateAudit = (history) => {
  history.push("/admin/stock/create-audit");
};

export const goToViewAudits = (history) => {
  history.push("/admin/stock/view-audits");
};